import { useState, useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import Upload from "./Upload";
import {Auth} from 'aws-amplify';
import Login from "./Login";
import "./style.css";


const fileTypes = ["JPG", "PNG", "GIF", "docx"];

export default function ImgDropAndCrop() {
  const [file, setFile] = useState(null);
  const [logged, setLogged] = useState(false);
  const handleChange = (file) => {
    setFile(file);
  };

  const isLogin = async () => {
    try{
        await Auth.currentAuthenticatedUser();
        setLogged(true);
    }
    catch{
      setLogged(false);
    }
  }
  useEffect(() => {
    isLogin();
  }, []);
  if(logged===true){
    if(file == null){
      return (
          <div className="imgDropDrag">
            <h1>Upload your setup picture here</h1>
            <FileUploader handleChange={handleChange} name="file" types={fileTypes} />
            <p>{file ? `File name: ${file.name}` : "no files uploaded yet"}</p>
          </div>
      );
    }
    else{
      return(
          <Upload image={file}/>);
    }
  }
  else{
    return (<Login/>);
  }
}